const useFeatureEnabled = require("../../src/client-ts/split/useFeatureEnabled")
  .useFeatureEnabled;

// eslint-disable-next-line
exports._useFeatureEnabled = (feature) => () => useFeatureEnabled(feature);
